import { type PropsWithChildren, type ReactNode } from 'react';

import { reduceZoomDomain } from '../../core/components/interactions-state-helpers/reducers/zoom-reducers.js';
import { getInitialZoomOut } from '../../core/components/zoom/utils/get-initial-zoom-out.js';
import { useSetState } from '../hooks/store/state-setters.js';
import { useHistogramFilteredData } from '../hooks/useHistogramFilteredData.js';

interface HistogramStateSyncProviderProps extends PropsWithChildren {
  currentDomain?: [number, number];
  initialDomain?: [number, number];
  infiniteZoom?: boolean;
}

export const HistogramStateSyncProvider = ({
  currentDomain,
  initialDomain,
  infiniteZoom,
  children,
}: HistogramStateSyncProviderProps): ReactNode => {
  const { minMaxXValue } = useHistogramFilteredData();
  const { min: minFromData, max: maxFromData } = minMaxXValue;
  const initialDomainRange = initialDomain ?? [minFromData, maxFromData];

  const setState = useSetState();

  setState(
    reduceZoomDomain(
      currentDomain,
      true,
      infiniteZoom || getInitialZoomOut(currentDomain, initialDomainRange),
    ),
  );

  return children;
};

HistogramStateSyncProvider['displayName'] = 'HistogramStateSyncProvider';
